module.exports = __webpack_public_path__ + "img/C000030.803a445e.png";